var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 1H18C18.5523 1 19 1.44772 19 2V9.5H10V10.5H19V11C19 11.5523 18.5523 12 18 12H10V13H18C19.1046 13 20 12.1046 20 11V2C20 0.895431 19.1046 0 18 0H4C2.89543 0 2 0.89543 2 2V5H3V2C3 1.44772 3.44772 1 4 1H13V3.79194C13 4.29504 13.582 4.57474 13.9748 4.26046L15 3.44031L16.0252 4.26046C16.418 4.57474 17 4.29504 17 3.79194V1ZM16 1V2.95969L15.3748 2.45954C15.1557 2.28424 14.8443 2.28424 14.6252 2.45954L14 2.95969V1H16ZM10 16.5H15C15.2761 16.5 15.5 16.2761 15.5 16C15.5 15.7239 15.2761 15.5 15 15.5H13V14H12V15.5H11V14H10V16.5ZM1 7L1 17H8V7H1ZM0 7C0 6.44771 0.447715 6 1 6H8C8.55229 6 9 6.44772 9 7V17C9 17.5523 8.55229 18 8 18H1C0.447715 18 0 17.5523 0 17V7ZM2.5 13.5C2.22386 13.5 2 13.7239 2 14C2 14.2761 2.22386 14.5 2.5 14.5H6.5C6.77614 14.5 7 14.2761 7 14C7 13.7239 6.77614 13.5 6.5 13.5H2.5ZM2 9C2 8.72386 2.22386 8.5 2.5 8.5H4.5C4.77614 8.5 5 8.72386 5 9C5 9.27614 4.77614 9.5 4.5 9.5H2.5C2.22386 9.5 2 9.27614 2 9ZM2.5 11C2.22386 11 2 11.2239 2 11.5C2 11.7761 2.22386 12 2.5 12H6.5C6.77614 12 7 11.7761 7 11.5C7 11.2239 6.77614 11 6.5 11H2.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateReport);
export default __webpack_public_path__ + "static/media/GenerateReport.6fbd8acf167cace4df6bcfdc97ae0dff.svg";
export { ForwardRef as ReactComponent };